require('../paging');
require('../tabindex');
require('../../template/pagination/pagination.html.js');
require('./pagination');

var MODULE_NAME = 'ui.bootstrap.module.pagination';

angular.module(MODULE_NAME, ['ui.bootstrap.pagination', 'uib/template/pagination/pagination.html']);

module.exports = MODULE_NAME;



//////////////////
// WEBPACK FOOTER
// ../~/angular-ui-bootstrap/src/pagination/index.js
// module id = 438
// module chunks = 0